import React, { Component } from 'react';
import { connect } from 'react-redux';
import Content from './Content';
import { withRouter } from 'react-router-dom';
import { convertPoseStringIntoArray, convertPoseArrayIntoString } from './helper';

const ContentManager = ({ poseLookupString, location, history, dispatch }) => {

    const paramString = "AAAAA-BBBBB-CCCCC+DDDDD-EEEEE-FFFFF+GGGGG-HHHHH-IIIII-JJJJJ+KKKKK-LLLLL-MMMMM-NNNNN+OOOOO-PPPPP+HHHHH-QQQQQ+RRRRR-SSSSS+TTTTT-UUUUU-VVVVV-WWWWW-XXXXX-YYYYY+ZZZZZ-ZAZA-ZBZB+ZCZC-ZDZD-ZEZE+ZFZF-ZGZG-ZHZH" //(!poseLookupString || poseLookupString === "") ? location.search.replace("?", "") : poseLookupString;

    //dispatch({type:'SET_POSELOOKUPSTRING_FROM_PARAM', poseLookupString:paramString})

    if (poseLookupString) {
      history.replace({search: '?' + poseLookupString})
    }

    const poseLookup = convertPoseStringIntoArray(paramString)

    return <Content poseLookup={poseLookup}/>

}

const mapStateToProps = (state) => ({
  poseLookupString: state.poseLookupString,
});

export default connect(mapStateToProps)(withRouter(ContentManager));



// WEBPACK FOOTER //
// ./src/ContentManager.js